import * as globalConstant from './global_constant';
var rp = require('request-promise').defaults({json: true})
const api_root = globalConstant.DATAFEED_URL;
const history = {}

export default {
	history: history,

    getBars: function(symbolInfo, resolution, from, to, first, limit) {
			var symbol = window.location.href.split(/[_/]/)
			var urlForDataFeed = '';
			if(symbol[3] === 'exchange'){
				urlForDataFeed = globalConstant.EXCHANGE_FEED_URL;
			}else{
				urlForDataFeed = globalConstant.COINDETAIL_FEED_URL;
			}

			const url = urlForDataFeed
			const qs = {
				fsym: symbol[4],
				tsym: symbol[5],
				fromTs:  from ? from : '',
				toTs:  to ? to : '',
				limit: limit ? limit : 2000, 
				resolution:resolution,
				aggregate: 1//resolution 
			}
        return rp({
                url: `${api_root}${url}`,
                qs,
            })
            .then(data => {
                //console.log({data})
				if (data.Response && data.Response === 'Error'){
					//console.log('API error:',data.Message)
					return []
				}
				if (data.Data.length){
					//console.log(`Actually returned: ${new Date(data.TimeFrom * 1000).toISOString()} - ${new Date(data.TimeTo * 1000).toISOString()}`)
					var bars = data.Data.map(el => {
						/* return {
							time: el.time * 1000, //TradingView requires bar time in ms
							low: el.low,
							high: el.high,
							open: el.open,
							close: el.close,
							volume: el.volumeto 
						} */
						return {
							time: el[0] * 1000, //TradingView requires bar time in ms
							low: el[3],
							high: el[2],
							open: el[1],
							close: el[4],
							volume: parseFloat(el[5])
						}
					})
					if (first) {
						var lastBar = bars[bars.length - 1]
						history[symbolInfo.name] = {lastBar: lastBar}
					}
					return bars
				} else {
					return []
				}
			})
	}
}



// WEBPACK FOOTER //
// src/components/TVChartContainer/api/historyProvider.js